// extracted by mini-css-extract-plugin
export default {"root":"Zyd5dwOwUuGVd6N2bk6w"};